<template>
    <div class="com-codics-hbb-order-admin-timeline-root">
        <!-- 订单时间线容器 -->
        <div class="com-codics-hbb-order-admin-timeline-container">
            <div class="iconfont com-codics-hbb-order-admin-timeline-title" style="cursor: pointer;" @click="goBack">
                &#xEA64; 订单管理 <span style="color: red;">（销售：{{ nowOrder?.account?.nickname || '无' }}）</span><span
                    style="color: blue;" @click.stop="jumpToWeb('客户详情', { id: nowOrder?.cusInfo?.id })">（客户：{{
                        nowOrder?.cusInfo?.name || '无' }}）</span>
            </div>
            <div class="com-codics-hbb-order-admin-timeline-title iconfont" style="margin-left: 20px;cursor: pointer;"
                @click="copyTxtFuc(orderId)">
                订单编号：{{ orderId }}&nbsp;&nbsp;&#xECD5;</div>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                trigger="click" title="您确定要取消当前订单吗？" @confirm="cancelOrderFuc([nowOrder.id])">
                <el-button v-show="nowOrder.state < 7" type="danger" size="mini" style="float: right;" slot="reference"
                    plain>订单取消</el-button>
            </el-popconfirm>
            <el-button v-if="nowOrder.state == 0" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain @click="nowId = nowOrder.id; pfVisible = true;">订单评级</el-button>
            <el-button v-if="nowOrder.state == 1" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; bjVisible = true; bjForm.title = '订单初始报价';">初始报价</el-button>
            <el-button v-if="nowOrder.state == 2" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; zzbjVisible = true; bjForm.title = '订单最终报价';">最终报价</el-button>
            <el-button v-if="nowOrder.state == 3" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; htVisible = true; bjForm.title = '上传订单合同';">上传合同</el-button>
            <el-button v-if="nowOrder.state == 4" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; zfVisible = true; bjForm.title = '上传支付记录';">订单支付</el-button>
            <el-button v-if="nowOrder.state == 5" size="mini" style="float: right;margin-right: 7px;" type="warning"
                plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; fhVisible = true; bjForm.title = '上传订单物流';">订单发货</el-button>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                @confirm="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state + 1; bjForm.type = nowOrder.type; wjVisible = true; bjForm.title = '订单已完成'; bjForm.mess = '订单已完成，客户已清关收货！'; bjOrderFuc();"
                icon-color="red" title="您确定要完结当前订单吗？">
                <el-button v-if="nowOrder.state == 6" size="mini" style="float: right;margin-right: 7px;"
                    slot="reference" type="warning" plain>完结订单</el-button>
            </el-popconfirm>
            <el-button size="mini" style="float: right;margin-right: 7px;" plain
                @click="bjForm.id = nowOrder.id; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state; bjForm.type = nowOrder.type; messVisible = true;">添加消息</el-button>
            <!-- 时间线容器 -->
            <div class="com-codics-hbb-order-admin-timeline-timeline-wrapper" style="margin-top: 90px !important;">
                <button
                    class="com-codics-hbb-order-admin-timeline-slide-btn com-codics-hbb-order-admin-timeline-prev-btn"
                    ref="prevBtn">
                    <svg viewBox="0 0 24 24">
                        <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" />
                    </svg>
                </button>

                <div class="com-codics-hbb-order-admin-timeline-timeline-container" ref="timelineContainer">
                    <!-- 循环渲染时间线节点（替换静态内容，方便维护） -->
                    <div v-for="(node, index) in (nowOrder.state == 8 ? [...timelineNodes.filter(node => node.messages.length > 0), {
                        status: 'completed',
                        time: this.stateEight[0]?.ctime || '无信息',
                        title: '订单已取消',
                        messages: [...this.stateNine]
                    }] : timelineNodes)" :key="index" :class="[
                        'com-codics-hbb-order-admin-timeline-timeline-node',
                        node.status === 'completed' ? 'com-codics-hbb-order-admin-timeline-completed' : '',
                        node.status === 'current' ? 'com-codics-hbb-order-admin-timeline-current' : ''
                    ]">
                        <div class="com-codics-hbb-order-admin-timeline-node-box">
                            <span class="com-codics-hbb-order-admin-timeline-node-number">{{ index + 1 }}</span>
                        </div>
                        <div class="com-codics-hbb-order-admin-timeline-node-time">{{ node.time }}</div>
                        <div class="com-codics-hbb-order-admin-timeline-node-title">{{ node.title }}</div>
                        <div class="com-codics-hbb-order-admin-timeline-node-message">
                            <div class="com-codics-hbb-order-admin-timeline-message-list">

                                <div class="com-codics-hbb-order-admin-timeline-message-list-empty"
                                    v-if="node.messages.length === 0">
                                    暂无消息
                                </div>
                                <!-- 循环渲染单条消息 -->
                                <div class="com-codics-hbb-order-admin-timeline-single-message"
                                    v-for="(msg, msgIndex) in node.messages" :key="msgIndex">
                                    <div class="com-codics-hbb-order-admin-timeline-single-message-title">{{ msg.title
                                        }}</div>
                                    <div class="com-codics-hbb-order-admin-timeline-text-attachment" v-html="msg.mess">
                                    </div>
                                    <!-- 附件区域：区分图片预览和文件下载 -->
                                    <div class="com-codics-hbb-order-admin-timeline-attachment-container"
                                        v-if="msg.attach && msg.attach.split(',').length > 0">
                                        <div class="com-codics-hbb-order-admin-timeline-attachment-item"
                                            v-for="(attach, attachIndex) in (msg.attach == '' ? [] : msg.attach.split(','))"
                                            :key="attachIndex">
                                            <!-- 图片附件：预览 -->
                                            <img v-if="isImageFile(attach)"
                                                :src="`https://cdn.bosscaigou.com/${attach}`" :alt="attach"
                                                class="com-codics-hbb-order-admin-timeline-attachment-img"
                                                @click="openImagePreview(`https://cdn.bosscaigou.com/${attach}`)" />
                                            <!-- 非图片附件：下载 -->
                                            <a v-else href="javascript:;"
                                                class="com-codics-hbb-order-admin-timeline-attachment-file"
                                                @click="downloadFile(`https://cdn.bosscaigou.com/${attach}`, `https://cdn.bosscaigou.com/${attach}`)">
                                                <svg viewBox="0 0 24 24"
                                                    class="com-codics-hbb-order-admin-timeline-download-icon">
                                                    <path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" />
                                                </svg>
                                                <span class="com-codics-hbb-order-admin-timeline-file-name">{{
                                                    attach.split('/').pop() }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="com-codics-hbb-order-admin-timeline-add iconfont"
                                    @click="messVisible = true; bjForm.oid = nowOrder.id; bjForm.state = nowOrder.state; bjForm.type = nowOrder.type;">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <button
                    class="com-codics-hbb-order-admin-timeline-slide-btn com-codics-hbb-order-admin-timeline-next-btn"
                    ref="nextBtn">
                    <svg viewBox="0 0 24 24">
                        <path d="M10,6L8.59,7.41L13.17,12L8.59,16.59L10,18L16,12L10,6Z" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="com-codics-hbb-order-admin-timeline-container"
            style="margin-top: 20px;float: left;box-sizing: border-box;">
            <div class="com-codics-book-admin-project-list-item" style="width: 20%;"
                v-for="(item, index) in nowOrder.list" :key="item.id">
                <div class="com-codics-book-admin-project-list-item-card"
                    :style="{ 'border': item.checked ? '1px solid #9333ea' : '1px solid #E5E5E5', '--opacity': item.checked ? '1' : '0' }">
                    <el-image class="com-codics-book-admin-project-list-item-card-img" v-if="item.product.attach == ''"
                        :src="item.product.himg.startsWith('http') ? item.product.himg : `https://cdn.bosscaigou.com/${item.product.himg}`"
                        fit="cover"></el-image>
                    <div class="com-codics-book-admin-project-list-item-card-img" v-else>
                        <div class="com-codics-book-admin-project-list-item-card-attach-item iconfont"
                            @click="downloadFile2(item2)" v-for="(item2, index2) in item.product.attach.split(',')"
                            :key="index2">&#xEA84;{{ item2 }}
                        </div>
                    </div>
                    <div class="com-codics-book-admin-project-list-item-card-bottom">
                        <span class="com-codics-book-admin-project-list-item-card-bottom-txt"
                            style="padding-left: 10px;">{{ item.product.name
                            }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 图片预览遮罩层 -->
        <div class="com-codics-hbb-order-admin-timeline-img-preview-mask" v-if="previewImgUrl"
            @click="closeImagePreview">
            <img :src="previewImgUrl" alt="图片预览" class="com-codics-hbb-order-admin-timeline-preview-img" />
        </div>
        <MyDialog :visible.sync="messVisible" title="添加消息" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="消息标题">
                    <el-input v-model="bjForm.title" style="width: 100%;" size="small" placeholder="请输入消息标题"></el-input>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="消息附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="消息内容" required>
                    <el-input type="textarea" placeholder="请输入消息内容" :autosize="{ minRows: 4, maxRows: 6 }"
                        v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain
                    @click="addOrderMessFuc">添加消息</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="messVisible = false;">取消添加</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="pfVisible" title="询盘评级" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="询盘评级" required>
                    <el-select style="width:100%;" size="small" v-model="nowPf" filterable remote reserve-keyword
                        placeholder="请选择询盘评级">
                        <el-option v-for="(item, index) in [
                            {
                                value: 5,
                                label: '优质询盘'
                            },
                            {
                                value: 4,
                                label: '高级询盘'
                            },
                            {
                                value: 3,
                                label: '中级询盘'
                            },
                            {
                                value: 2,
                                label: '普通询盘'
                            },
                            {
                                value: 1,
                                label: '垃圾询盘'
                            }
                        ]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="rateOrderFuc">确认评级</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="pfVisible = false;">取消评级</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="bjVisible" title="初始报价" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="报价单附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="报价备注" required>
                    <el-input type="textarea" autosize placeholder="请输入报价备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">初始报价</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="bjVisible = false;">取消报价</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="zzbjVisible" title="最终报价" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="报价单附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="报价备注" required>
                    <el-input type="textarea" autosize placeholder="请输入报价备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">最终报价</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="zzbjVisible = false;">取消报价</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="htVisible" title="上传合同" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="合同附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="合同备注" required>
                    <el-input type="textarea" autosize placeholder="请输入合同备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传合同</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="htVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="zfVisible" title="订单支付" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="支付记录附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="支付备注" required>
                    <el-input type="textarea" autosize placeholder="请输入支付备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传支付记录</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="zfVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="fhVisible" title="订单发货" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="物流记录附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="物流备注" required>
                    <el-input type="textarea" autosize placeholder="请输入物流备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传物流记录</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fhVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<script>
import { infoOrder, addOrderMess, bjOrder, rateOrder, cancelOrder } from '@/api';
import { jumpTo, copyTxt } from '@/utils/myutils';
import MyUpload from '@/components/MyUpload';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import MyDialog from '@/components/MyDialog';
import { saveAs } from 'file-saver';
export default {
    name: "ComCodicsHbbOrderAdminTimeline",
    data() {
        return {
            pfVisible: false,
            nowPf: 5,
            bjVisible: false,
            zzbjVisible: false,
            htVisible: false,
            zfVisible: false,
            fhVisible: false,
            messVisible: false,
            nowOrder: {
                state: 0,
                type: 0,
                idel: 0
            },
            orderId: '',
            // 预览图片地址
            previewImgUrl: "",
            // 滑动步长
            slideStep: 600,
            // 时间线节点数据（结构化，方便维护和扩展）
            // timelineNodes: [
            //     {
            //         status: "completed",
            //         time: "2026-01-29 10:00:00",
            //         title: "提交订单",
            //         messages: [
            //             {
            //                 title: "订单创建成功",
            //                 content: "您已成功提交订单，订单编号：ORD20260129002，订单金额：¥1299.00。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "支付提醒",
            //                 content: "请在24小时内完成支付，逾期订单将自动关闭，支持微信、支付宝、银行卡支付。",
            //                 attachments: [
            //                     {
            //                         name: "支付方式说明.png",
            //                         url: "https://picsum.photos/200/200?random=5"
            //                     }
            //                 ]
            //             }
            //         ]
            //     },
            //     {
            //         status: "completed",
            //         time: "2026-01-29 10:08:00",
            //         title: "支付完成",
            //         messages: [
            //             {
            //                 title: "支付成功通知",
            //                 content: "您已通过支付宝完成订单支付，支付金额：¥1299.00，支付流水号：ALIPAY20260129100800。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "订单状态更新",
            //                 content: "订单已从「待支付」更新为「待发货」，仓库将在24小时内处理您的订单。",
            //                 attachments: [
            //                     {
            //                         name: "支付凭证.jpg",
            //                         url: "https://picsum.photos/200/200?random=6"
            //                     },
            //                     {
            //                         name: "订单详情.pdf",
            //                         url: "https://example.com/订单详情.pdf" // 示例非图片文件
            //                     }
            //                 ]
            //             }
            //         ]
            //     },
            //     {
            //         status: "current",
            //         time: "2026-01-29 15:30:00",
            //         title: "仓库发货",
            //         messages: [
            //             {
            //                 title: "订单打包完成",
            //                 content: "您的商品已完成打包，商品明细：XX商品*1，包装材料：防震泡沫+硬纸盒。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "快递揽收成功",
            //                 content: "您的订单已由仓库发出，快递公司：京东物流，快递单号：JD1234567890123。",
            //                 attachments: [
            //                     {
            //                         name: "快递面单.png",
            //                         url: "https://picsum.photos/200/200?random=7"
            //                     }
            //                 ]
            //             },
            //             {
            //                 title: "物流查询提醒",
            //                 content: "您可通过京东物流官网或APP查询包裹实时轨迹，预计3个工作日内送达。",
            //                 attachments: [
            //                     {
            //                         name: "打包照片.jpg",
            //                         url: "https://picsum.photos/200/200?random=8"
            //                     }
            //                 ]
            //             }
            //         ]
            //     },
            //     {
            //         status: "",
            //         time: "待更新",
            //         title: "物流运输",
            //         messages: [
            //             {
            //                 title: "物流待更新",
            //                 content: "您的包裹正在运输途中，敬请等待物流轨迹更新，如有疑问可联系快递公司客服。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "异常提醒",
            //                 content: "若超过48小时无物流更新，请联系平台客服协助查询，客服热线：400-XXXX-XXXX。",
            //                 attachments: []
            //             }
            //         ]
            //     },
            //     {
            //         status: "",
            //         time: "待完成",
            //         title: "确认签收",
            //         messages: [
            //             {
            //                 title: "签收提醒",
            //                 content: "包裹送达后，请确认商品完好无损、数量无误后再完成签收。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "售后说明",
            //                 content: "签收后7天内如遇商品质量问题，可申请无理由退换货，退换货流程可在个人中心查看。",
            //                 attachments: []
            //             }
            //         ]
            //     },
            //     {
            //         status: "",
            //         time: "待完成",
            //         title: "订单完成",
            //         messages: [
            //             {
            //                 title: "订单完成通知",
            //                 content: "订单已完成，感谢您的购买，您的满意是我们最大的动力。",
            //                 attachments: []
            //             },
            //             {
            //                 title: "好评有礼",
            //                 content: "完成商品好评可获得100积分，积分可在下次购物时抵扣现金，详情请查看积分规则。",
            //                 attachments: []
            //             }
            //         ]
            //     }
            // ],
            nowOrder: {},
            stateOne: [],
            stateTwo: [],
            stateThree: [],
            stateFour: [],
            stateFive: [],
            stateSix: [],
            stateSeven: [],
            stateEight: [],
            stateNine: [],
            bjForm: {
                oid: null,
                title: '',
                mess: '',
                attach: '',
                attachs: [],
                state: 0,
                type: 0,
                idel: 0
            }
        };
    },
    methods: {
        downloadFile2(item) {
            saveAs(`https://cdn.bosscaigou.com/${item}`, item.split('/').pop());
        },
        goBack() {
            console.log(window.hbbHistory)
            if (window.hbbHistory && window.hbbHistory.length > 0) {
                this.$router.go(-1) // 返回上一页
            } else {
                this.jumpToWeb('产品订单管理') // 兜底跳首页
            }
        },
        async cancelOrderFuc(id) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await cancelOrder({ id: id });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单取消成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async bjOrderFuc() {
            if (this.bjForm.id == null) {
                this.$message.error('请选择订单！');
                return;
            }
            if (this.bjForm.oid == null) {
                this.$message.error('请选择订单！');
                return;
            }
            if (this.bjForm.mess == '') {
                this.$message.error('请输入报价备注消息！');
                return;
            }
            this.bjForm.attach = this.bjForm.attachs.join(',');
            this.bjForm.attachs = [];
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await bjOrder(this.bjForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '初始报价成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.$message.error(data.message);
            }
        },
        async rateOrderFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await rateOrder({
                id: this.nowId,
                rate: this.nowPf,
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '评级成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.$message.error(data.message);
            }
        },
        copyTxtFuc(txt) {
            copyTxt(txt);
            this.$message({
                message: '内容复制成功！',
                type: 'success'
            });
        },
        async addOrderMessFuc() {
            if (this.bjForm.oid == null) {
                this.$message.error('请选择订单！');
                return;
            }
            if (this.bjForm.mess == '') {
                this.$message.error('请输入报价备注消息！');
                return;
            }
            this.bjForm.attach = this.bjForm.attachs.join(',');
            this.bjForm.attachs = [];
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addOrderMess(this.bjForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '添加订单消息成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.$message.error(data.message);
            }
        },
        // 跳转订单管理页面
        jumpToWeb(url, p, q) {
            jumpTo(this, url, p || {}, q || {});
        },
        async getOrderInfo() {
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const res = await infoOrder({
                id: this.$route.params.id
            });
            loading.close();
            if (res.code === 200) {
                this.nowOrder = res.data;
                this.orderId = res.data.oid;
                // this.timelineNodes = res.data.timelineNodes;
                res.data.mess.forEach(item => {
                    if (item.state == 0) {
                        this.stateOne.push(item);
                    } else if (item.state == 1) {
                        this.stateTwo.push(item);
                    } else if (item.state == 2) {
                        this.stateThree.push(item);
                    } else if (item.state == 3) {
                        this.stateFour.push(item);
                    } else if (item.state == 4) {
                        this.stateFive.push(item);
                    } else if (item.state == 5) {
                        this.stateSix.push(item);
                    } else if (item.state == 6) {
                        this.stateSeven.push(item);
                    } else if (item.state == 7) {
                        this.stateEight.push(item);
                    } else if (item.state == 8) {
                        this.stateNine.push(item);
                    }
                })
            } else {
                this.$message.error(res.message);
            }
        },
        // 上一页滑动
        handlePrevClick() {
            const timelineContainer = this.$refs.timelineContainer;
            if (timelineContainer) {
                timelineContainer.scrollLeft -= this.slideStep;
            }
        },
        // 下一页滑动
        handleNextClick() {
            const timelineContainer = this.$refs.timelineContainer;
            if (timelineContainer) {
                timelineContainer.scrollLeft += this.slideStep;
            }
        },
        // 滚轮横向滑动处理
        handleWheel(e) {
            e.preventDefault();
            const timelineContainer = this.$refs.timelineContainer;
            if (timelineContainer) {
                timelineContainer.scrollLeft += e.deltaY * 2;
            }
        },
        // 检查按钮状态（是否禁用/透明）
        checkBtnStatus() {
            const timelineContainer = this.$refs.timelineContainer;
            const prevBtn = this.$refs.prevBtn;
            const nextBtn = this.$refs.nextBtn;
            if (!timelineContainer || !prevBtn || !nextBtn) return;

            const isAtStart = timelineContainer.scrollLeft <= 10;
            const isAtEnd = timelineContainer.scrollLeft >= (timelineContainer.scrollWidth - timelineContainer.clientWidth - 10);

            prevBtn.style.opacity = isAtStart ? '0.5' : '1';
            prevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';

            nextBtn.style.opacity = isAtEnd ? '0.5' : '1';
            nextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
        },
        // 判断是否为图片文件
        isImageFile(fileName) {
            const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
            const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
            return imageExts.includes(ext);
        },
        // 打开图片预览
        openImagePreview(imgUrl) {
            this.previewImgUrl = imgUrl;
            // 禁止页面滚动
            document.body.style.overflow = 'hidden';
        },
        // 关闭图片预览
        closeImagePreview() {
            this.previewImgUrl = "";
            // 恢复页面滚动
            document.body.style.overflow = 'auto';
        },
        // 下载文件
        downloadFile(fileUrl, fileName) {
            // 创建临时a标签
            const a = document.createElement('a');
            a.href = fileUrl;
            a.download = fileName || '下载文件';
            document.body.appendChild(a);
            // 触发点击下载
            a.click();
            // 移除临时a标签
            document.body.removeChild(a);
        }
    },
    mounted() {
        this.getOrderInfo();
        const timelineContainer = this.$refs.timelineContainer;
        const prevBtn = this.$refs.prevBtn;
        const nextBtn = this.$refs.nextBtn;

        // 绑定点击事件
        if (prevBtn) {
            prevBtn.addEventListener('click', this.handlePrevClick);
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', this.handleNextClick);
        }
        if (timelineContainer) {
            timelineContainer.addEventListener('wheel', this.handleWheel);
            timelineContainer.addEventListener('scroll', this.checkBtnStatus);
        }

        // 初始化按钮状态
        this.$nextTick(() => {
            this.checkBtnStatus();
        });
    },
    beforeDestroy() {
        // 解绑事件，防止内存泄漏
        const timelineContainer = this.$refs.timelineContainer;
        const prevBtn = this.$refs.prevBtn;
        const nextBtn = this.$refs.nextBtn;

        if (prevBtn) {
            prevBtn.removeEventListener('click', this.handlePrevClick);
        }
        if (nextBtn) {
            nextBtn.removeEventListener('click', this.handleNextClick);
        }
        if (timelineContainer) {
            timelineContainer.removeEventListener('wheel', this.handleWheel);
            timelineContainer.removeEventListener('scroll', this.checkBtnStatus);
        }
    },
    computed: {
        // 计算时间线节点数量
        timelineNodes() {
            return [
                {
                    status: this.nowOrder.state >= 0 ? 'completed' : 'current',
                    time: this.nowOrder.ctime || '无信息',
                    title: "添加询盘",
                    messages: [...this.stateOne]
                },
                {
                    status: this.nowOrder.state >= 1 ? 'completed' : 'current',
                    time: this.stateTwo[0]?.ctime || '无信息',
                    title: "询盘评级",
                    messages: [...this.stateTwo]
                },
                {
                    status: this.nowOrder.state >= 2 ? 'completed' : 'current',
                    time: this.stateThree[0]?.ctime || '无信息',
                    title: "初始报价",
                    messages: [...this.stateThree]
                },
                {
                    status: this.nowOrder.state >= 3 ? 'completed' : 'current',
                    time: this.stateFour[0]?.ctime || '无信息',
                    title: "终极报价",
                    messages: [...this.stateFour]
                },
                {
                    status: this.nowOrder.state >= 4 ? 'completed' : 'current',
                    time: this.stateFive[0]?.ctime || '无信息',
                    title: "生成订单",
                    messages: [...this.stateFive]
                },
                {
                    status: this.nowOrder.state >= 5 ? 'completed' : 'current',
                    time: this.stateSix[0]?.ctime || '无信息',
                    title: "订单支付",
                    messages: [...this.stateSix]
                },
                {
                    status: this.nowOrder.state >= 6 ? 'completed' : 'current',
                    time: this.stateSeven[0]?.ctime || '无信息',
                    title: "订单发货",
                    messages: [...this.stateSeven]
                },
                {
                    status: this.nowOrder.state >= 7 ? 'completed' : 'current',
                    time: this.stateEight[0]?.ctime || '无信息',
                    title: "订单完成",
                    messages: [...this.stateEight]
                }
            ];
        }
    },
    components: {
        MyUpload,
        MyForm,
        MyFormItem,
        MyDialog
    }
};
</script>

<style>
/* 全局重置 & 基础样式（商务黑白风） */
.com-codics-hbb-order-admin-timeline-root * {
    box-sizing: border-box;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #333;
}

.com-codics-hbb-order-admin-timeline-timeline-wrapper * {
    margin: 0;
    padding: 0;
}

.com-codics-hbb-order-admin-timeline-root {
    background-color: #f9f9f9;
    padding: 20px 20px;
    width: 100%;
    overflow: auto;
    /* 内容宽度100% */
}

/* 容器：宽度100%，移除固定最大宽度 */
.com-codics-hbb-order-admin-timeline-container {
    width: 100%;
    /* 核心：内容宽度100% */
    margin: 0 auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.04);
    position: relative;
}

.com-codics-hbb-order-admin-timeline-order-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 40px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eaeaea;
}

/* 时间线容器（核心：横向滚动） */
.com-codics-hbb-order-admin-timeline-timeline-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: 60px;
    padding: 0 30px;
}

.com-codics-hbb-order-admin-timeline-timeline-container {
    display: flex;
    gap: 50px;
    padding: 25px 0;
    overflow-x: auto;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-left: 40px;
    padding-right: 40px;
    width: 100%;
    /* 核心：内容宽度100% */
}

.com-codics-hbb-order-admin-timeline-timeline-container::-webkit-scrollbar {
    display: none;
}

/* 左右滑动按钮 - 优化位置，不遮挡节点 */
.com-codics-hbb-order-admin-timeline-slide-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.2s ease;
    left: 10px;
}

.com-codics-hbb-order-admin-timeline-slide-btn:hover {
    background-color: #f0f0f0;
    border-color: #ddd;
}

.com-codics-hbb-order-admin-timeline-next-btn {
    left: auto;
    right: 10px;
}

.com-codics-hbb-order-admin-timeline-slide-btn svg {
    width: 18px;
    height: 18px;
    fill: #555;
}

/* 时间线节点 - 核心优化：固定宽度匹配消息卡片，确保节点居中 */
.com-codics-hbb-order-admin-timeline-timeline-node {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 320px;
    min-width: 320px;
    position: relative;
    margin: 0;
}

/* 节点连线（除了最后一个节点） - 核心优化：调整连线位置，匹配新的节点宽度 */
.com-codics-hbb-order-admin-timeline-timeline-node:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 160px;
    width: 360px;
    height: 1px;
    background-color: #eaeaea;
    z-index: 1;
    border-top: 1px dashed #ccc;
}

/* 节点方块 - 保持原有样式，确保视觉一致性 */
.com-codics-hbb-order-admin-timeline-node-box {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background-color: #fff;
    border: 2px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    z-index: 2;
    transition: all 0.2s ease;
    margin-left: auto;
    margin-right: auto;
}

/* 已完成节点样式 */
.com-codics-hbb-order-admin-timeline-completed .com-codics-hbb-order-admin-timeline-node-box {
    background-color: #000;
    border-color: #000;
    color: #fff;
}

/* 当前节点样式 */
.com-codics-hbb-order-admin-timeline-current .com-codics-hbb-order-admin-timeline-node-box {
    /* width: 44px;
    height: 44px; */
    border-color: #000;
    background-color: #fff;
    font-weight: 600;
}

.com-codics-hbb-order-admin-timeline-node-number {
    font-size: 14px;
    color: #666;
}

.com-codics-hbb-order-admin-timeline-completed .com-codics-hbb-order-admin-timeline-node-number,
.com-codics-hbb-order-admin-timeline-current .com-codics-hbb-order-admin-timeline-node-number {
    color: #000;
}

.com-codics-hbb-order-admin-timeline-completed .com-codics-hbb-order-admin-timeline-node-number {
    color: #fff;
}

/* 节点时间 & 标题 - 强制居中，匹配节点和卡片 */
.com-codics-hbb-order-admin-timeline-node-time {
    font-size: 12px;
    color: #999;
    margin-bottom: 8px;
    text-align: center;
    width: 100%;
}

.com-codics-hbb-order-admin-timeline-completed .com-codics-hbb-order-admin-timeline-node-time,
.com-codics-hbb-order-admin-timeline-current .com-codics-hbb-order-admin-timeline-node-time {
    color: #222;
    font-weight: 500;
}

.com-codics-hbb-order-admin-timeline-node-title {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
}

/* 节点消息卡片 - 核心：宽度固定，与节点匹配，确保节点在正上方 */
.com-codics-hbb-order-admin-timeline-node-message {
    width: 320px;
    height: fit-content;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    padding: 18px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: all 0.3s ease;
    cursor: default;
    margin: 0 auto;
    max-height: calc(100vh - 350px);
    overflow-y: auto;
}

/* Hover 放大效果 */
.com-codics-hbb-order-admin-timeline-node-message:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
    border-color: #ddd;
}

/* 多条消息列表容器 */
.com-codics-hbb-order-admin-timeline-message-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* 单条消息项样式 */
.com-codics-hbb-order-admin-timeline-single-message {
    padding: 12px;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px solid #f0f0f0;
}

/* 单条消息标题 */
.com-codics-hbb-order-admin-timeline-single-message-title {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f5f5f5;
}

/* 文本附件 */
.com-codics-hbb-order-admin-timeline-text-attachment {
    font-size: 12px;
    color: #666;
    line-height: 1.7;
    margin-bottom: 12px;
    white-space: break-spaces;
}

/* 附件容器（整合图片和文件） */
.com-codics-hbb-order-admin-timeline-attachment-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.com-codics-hbb-order-admin-timeline-attachment-item {
    display: flex;
    align-items: center;
}

/* 图片附件 */
.com-codics-hbb-order-admin-timeline-attachment-img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #eaeaea;
    transition: all 0.2s ease;
    cursor: zoom-in;
}

.com-codics-hbb-order-admin-timeline-attachment-img:hover {
    border-color: #ddd;
    transform: scale(1.05);
}

/* 非图片附件（下载） */
.com-codics-hbb-order-admin-timeline-attachment-file {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    font-size: 12px;
    color: #1890ff;
    padding: 8px 12px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.com-codics-hbb-order-admin-timeline-attachment-file:hover {
    background-color: #f0f7ff;
    border-color: #1890ff;
}

.com-codics-hbb-order-admin-timeline-download-icon {
    width: 16px;
    height: 16px;
    fill: #1890ff;
}

.com-codics-hbb-order-admin-timeline-file-name {
    color: #1890ff;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 图片预览遮罩层 */
.com-codics-hbb-order-admin-timeline-img-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: zoom-out;
}

.com-codics-hbb-order-admin-timeline-preview-img {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px;
    object-fit: contain;
}

.com-codics-hbb-order-admin-timeline-message-list-empty {
    height: 80px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 14px;
    color: #666;
    text-align: center;
    line-height: 80px;
}

.com-codics-hbb-order-admin-timeline-add {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    border-radius: 2px;
    border: 1px dashed #999;
    cursor: pointer;
    transition: 0.3s;
}

.com-codics-hbb-order-admin-timeline-add::before,
.com-codics-hbb-order-admin-timeline-add::after {
    content: "";
    position: absolute;
    margin: auto;
    height: 1px;
    width: 12px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #999;
    transform-origin: center center;
}

.com-codics-hbb-order-admin-timeline-add::after {
    transform: rotate(90deg);
}

.com-codics-hbb-order-admin-timeline-add:hover {
    border-color: #000;
}

.com-codics-hbb-order-admin-timeline-add:hover::before,
.com-codics-hbb-order-admin-timeline-add:hover::after {
    background: #000;
}

.com-codics-hbb-order-admin-timeline-title {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
}

.com-codics-hbb-order-admin-timeline-product-list {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}
</style>